module.exports = __webpack_public_path__ + "static/media/rocket.19dfbbb1.png";